angular.module('hal-common', []);
